import produce from 'immer';
import create from 'zustand';

const useStore = create(set => ({
  assetClasses: [],
  categories: [],
  set: fn => set(produce(fn)),
}));

export default useStore;
